<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">    
                <CRow class="p-2 m-0">
                    <CCol md="6" sm="12">
                        <!-- Filter -->
                        <FilterLeads 
                        />
                    </CCol>
                    <CCol
                        md="5"
                        sm="12"
                    >
                        <FilterDate
                        />
                    </CCol>
                    <CCol
                        md="1"
                        sm="12"
                    >
                        <CButton
                            @click="updateData"
                            class="button-filter"
                        >
                            {{ $t('filter') }}
                        </CButton>
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterAdvance 
                            :fields="traslateLabels(tables.leads.fields)"
                            @filterData="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow alignVertical="center" alignHorizontal="center" class="p-2 m-0">
                    <CCol md="7" sm="12">
                        <CCard>
                            <CCardBody>
                                {{$t('total')}}: {{ tables.leads.items.length }}
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            

                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.leads.items"
                                    :fields="traslateLabels(tables.leads.fields)"
                                    :items-per-page="tables.leads.rows"
                                    @pagination-change="itemPerPage"
                                    items-per-page-select
                                    :itemsPerPageSelect="{
                                        values:[5, 10, 20, 50, 100, 500, 1000, 5000, 10000]
                                    }"
                                    :loading="tables.leads.loading"
                                    hover
                                    striped
                                    border
                                    v-export
                                >
                                <template #no-items-view>
                                        <slot name="no-items-view">
                                            <div class="block-no-items section">
                                               <!--  <span class="emoji">&#128557;</span> -->
                                                    <br>
                                                <h2
                                                    class="section__title text-no-items"
                                                >
                                                    {{
                                                        $t(
                                                            "no-items-text.leads"
                                                        )
                                                    }}                                                    
                                                </h2>
                                            </div>
                                        </slot>
                                    </template>
                                    <template #over-table>
                                        <!-- <TableSettings :fields="tables.leads.fields" /> -->
                                        <TableSettings
                                            :allFields="tables.leads.allFields"
                                            :activeFields.sync="tables.leads.fields"
                                        />
                                    </template>

                                    <template #birth_date="{ item }">
                                           <td>
                                                {{ item.birth_date.split(" ")[0] }}
                                            </td>
                                    </template>

                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <button
                                                class="m-2 p-0 btn-export-table"
                                                @click="downloadExportTable({
                                                    tableName: 'leads'
                                                })"
                                            >
                                                <span class="block-icon">
                                                    <CIcon  :content="$options.icons.cilDataTransferDown "/>
                                                </span>
                                                <span class="text">
                                                    {{ $t("export_to_csv") }}
                                                </span>
                                            </button>
                                        </div>
                                        
                                    </template>

                                    

                                </CDataTable>

                            </CCardBody>
                            <CCardFooter
                                v-if="tables.leads.total_pages > 0"
                            >
                                <CPagination
                                    @update:activePage="updatePagination"
                                    :activePage="tables.leads.page"
                                    :pages="tables.leads.total_pages"
                                    align="center"
                                />
                            </CCardFooter>
                        </CCard>
                        
                        
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
  
</template>

<script>
import TitlePage from "£lement/titlePage";
import FilterLeads from "£lement/FilterLeads";
import FilterAdvance from "~/components/FilterAdvance";
import TableSettings from "£lement/TableSettings";
import FilterDate from "~/components/FilterDate";
import { mapGetters } from "vuex";
import { cilWarning,cilPlus, cilDataTransferDown,cilSettings } from '@coreui/icons';
import pageMixin from '~/mixins/page.js';
import dateMixin from '~/mixins/date.js';

import tableMixin from '~/mixins/table.js';
import toolsMixin from '~/mixins/tools.js';

export default {
    name:"LeadsPage",
    middleware: ["auth","page"],
    mixins: [ pageMixin, dateMixin, tableMixin, toolsMixin ],
    components:{
        TitlePage,
        FilterLeads,
        FilterAdvance,
        FilterDate,
        TableSettings
    },
    icons:{
        cilWarning,
        cilPlus,
        cilDataTransferDown,
        cilSettings 
    },
    data(){
        return{
            tables:{
                leads:{
                    fields:[
                        {
                            key: "id",
                            label:"#",
                            sorter: false,
                            _filter: false,
                            fixed: true,
                        },
                        {
                            key: "email",
                            label:"email",
                            sorter: false,
                            _filter: true,
                        },
                        {
                            key: "first_name",
                            label:"first_name",
                            sorter: false,
                            _filter: true,
                        },
                        {
                            key: "last_name",
                            label:"last_name",
                            sorter: false,
                            _filter: true,
                        },
                        {
                            key: "genre",
                            label:"gender",
                            sorter: false,
                            _filter: true,
                        },
                        {
                            key: "birth_date",
                            label:"birth_date",
                            sorter: false,
                            _filter: true,
                        },
                        {
                            key: "dbName",
                            label:"database",
                            sorter: false,
                            _filter: true,
                        },
                        {
                            key: "providerName",
                            label:"inputs",
                            sorter: false,
                            _filter: true,
                        },
                        {
                            key: "origin",
                            label:"origin",
                            sorter: false,
                            _filter: true,
                        },
                        {
                            key: "created_on",
                            label:"creation_date",
                            sorter: false,
                            _filter: false,
                        },
                        {
                            key: "state",
                            label:"state",
                            sorter: false,
                            _filter: {
                                active:false,
                                value:null,
                                condition:"is_equal_to",
                                type:'select',
                                options:[
                                    { value: 'count', label: this.$t('new')}, 
                                    { value: 'duplicate', label: this.$t('duplicates')}, 
                                    { value: 'deduplicate', label: this.$t('deduplicate')}, 
                                ]
                            },
                        },
                    ],
                    allFields:[],
                    items:[],
                    order:'desc',
                    rows:50,
                    page:1,
                    total_pages:0,
                    loading:false,
                },
            },
            modals:{
                dowloadTable:{
                    show:false,
                }
            }
        }
    },
    computed:{
        ...mapGetters({
            storeFrom:"filter/from",
            storeTo:"filter/to",
            storeLeadType:'filter/leadType',
            storeDatabase:'filter/database',
            storeFilterAdvance:'filter/filter_advance'
        })
    },
    methods:{
        itemPerPage(newValue){
            this.tables.leads.rows = newValue;
            this.updatePagination(this.tables.leads.page);
        },
        updatePagination(newValue){
            this.tables.leads.page = newValue;
            this.updateData();
        },

        formatDate(date = new Date()) {
            let dateFormat = [
                    ("0000" + date.getFullYear()).slice(-4),
                    ("00" + (date.getMonth()+1)).slice(-2),
                    ("00" + date.getDate()).slice(-2),
                ].join('-')+' '+
                [
                    ("00" + date.getHours()).slice(-2),
                    ("00" + date.getMinutes()).slice(-2),
                    ("00" + date.getSeconds()).slice(-2)
                ].join(':');
            return dateFormat;
        },
        async updateTable({ tableName, url, method = 'GET'}){
            let from = this.storeFrom;
            let to = this.storeTo;
            let rows = this.tables[tableName].rows;
            let page = this.tables[tableName].page;
            this.tables[tableName].loading = true;

            let tableFilter = {
                created_on:{
                    condition:"between",
                    value:[from,to],
                    expression_type:"filter"
                },
                dbId:{
                    value:this.storeDatabase.toString(),
                    condition:"is_equal_to",
                    expression_type:"condition"
                },
            };

            if(this.storeFilterAdvance){
                tableFilter = {
                    ...tableFilter,
                    ...this.storeFilterAdvance
                }
            }

            let tablePagination = {
                page,
                rows,
            }
            
            let tableData = await this.fetcher({ 
                url,
                method,
                query:{
                    filter:tableFilter,
                    pagination:tablePagination,
                }
            });

            this.tables[tableName].items = this.normalizeArrayData({
                data:tableData.message
            });

            let headers = [];

            if(tableData.message[0]){
                for (const key in tableData.message[0]) {
                    headers.push(key);
                }
            }else{
                headers = this.tables[tableName].fields; 
            }

            this.tables[tableName].allFields = headers;
            this.tables[tableName].loading = false;
            this.$store.dispatch('page/updateTables', {
                ...this.tables[tableName],
                name: tableData,
                allFields: headers,
            });
        },

        async updateData() {
            this.updatePageLoading(true);
            await this.updateTable({ 
                tableName:'leads', 
                url:'/lead.api/GetFilteredLeads',
                method:'POST'
            });
            this.updatePageLoading(false);
        }
    },
    mounted(){
        this.tables.leads.allFields = this.tables.leads.fields.map(( item )=> item.key);
        this.updatePageLoading(false);
    }

}
</script>

<style>
    .button-filter{
        display: block;
        margin-right: 0;
        margin-left: auto;
    }
</style>